import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionBannerItemSchema = z.object({
  image: z.object({
    path: z.string().optional().nullable(),
    alt: z.string().optional().nullable()
  }).optional().nullable(),
  text: z.string()
});
const FeatureSectionBannerSchema = z.object({
  data: z.object({
    id: z.string().optional().nullable(),
    parts: FeatureSectionBannerItemSchema.array().optional().nullable(),
    title: z.string().optional().nullable()
  }).merge(SectionSpacingSchema)
});
export default FeatureSectionBannerSchema;
